import { isUserLoggedIn } from '_services/LocalStorage/LoggedIn';
import ReferralAttributionService from '_services/Referral/ReferralAttributionService';
import { getUser, setUser } from '_services/Redux/User/UserSlice';
import { RootReduxStateShape } from '_types/Redux';
import { UserShape } from '_types/User';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

type Return = {
    user: UserShape | undefined;
    updateUser: (data: UserShape) => void;
};

global.isFetchingUser = false;

const useUser = (): Return => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootReduxStateShape) => state.user.data);
    const requestMade = useRef(false);

    useEffect(() => {
        if (
            !requestMade.current &&
            isUserLoggedIn() &&
            !user &&
            !global.isFetchingUser
        ) {
            global.isFetchingUser = true;
            requestMade.current = true;
            dispatch(getUser());
        }

        if (user) {
            void ReferralAttributionService.claimForLoggedInUser(user.id);
        }
    }, [dispatch, user]);

    const updateUser = useCallback(
        (data: UserShape) => {
            dispatch(setUser(data));
        },
        [dispatch],
    );

    return { user, updateUser };
};

export default useUser;
